<template>
  <div class="boxed-category">
    <md-tabs
      :md-active-tab="application.loan.asset.type"
      @md-changed="application.loan.asset.type = $event"
      md-dynamic-height
    >
      <md-tab id="Personal Secured" md-label="Secured PL" :md-disabled="isCommercialLoan">
        <AssetSecurityEditor securityType="secured" :value="application"></AssetSecurityEditor>
      </md-tab>

      <md-tab id="Personal Unsecured" md-label="Unsecured PL" :md-disabled="isCommercialLoan">
        <div class="boxed-category">
          <md-subheader>Unsecured Loan Details</md-subheader>
          <div class="md-layout input-layout">

          <!-- Description -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-40"
            label="Description"
            prefixLabel="Unsecured"
            v-model="application.loan.asset.unsecured.description"
          >
          </validated-text-input>

          <!-- Purchase Cost -->
          <validated-input
            type="CURRENCY"
            class="md-layout-item md-small-size-100 md-size-15"
            label="Requested Loan Amount"
            prefixLabel="Unsecured"
            prefix="$"
            v-model="application.loan.asset.unsecured.requested_amount"
          />
        </div>
        </div>
      </md-tab>

      <md-tab id="Vehicle" md-label="Vehicle" md-dynamic-height >
        <AssetSecurityEditor securityType="vehicle" :value="application"></AssetSecurityEditor>
        <div class="padding" v-if="glasses.length > 0" v-show="show_glasses">
          <group-card
            title="Possible Existing Vehicle Infomation Match Found"
            icon="fact_check" >

            <md-table v-model="glasses" class="">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Variant" md-sort-by="variant">{{ item.variant }}</md-table-cell>
                <md-table-cell md-label="Style">{{ item.style }}</md-table-cell>
                <md-table-cell md-label="Injection">{{ item.injection }}</md-table-cell>
                <md-table-cell md-label="Series">{{ item.series }}</md-table-cell>
                <md-table-cell md-label="Engine CC">{{ item.engine_cc }}</md-table-cell>
                <md-table-cell md-label="Transmission">{{ item.transmission }}</md-table-cell>
                <md-table-cell md-label="Cylinders">{{ item.cylinders }}</md-table-cell>
                <md-table-cell md-label="Price" md-sort-by="a_avg_price">{{ item.a_avg_price | currency(0) }}</md-table-cell>
                <md-table-cell md-label="NVIC">{{ item.nvic }}</md-table-cell>
                <md-table-cell md-label="Action"><md-button
                  class="md-icon-button md-primary md-simple"
                  @click="selectVehicle(item)"
                >
                  <md-icon>launch</md-icon>
                  <md-tooltip md-direction="top">Select Vehicle</md-tooltip>
                </md-button></md-table-cell>
              </md-table-row>
            </md-table>

          </group-card>
        </div>

        <div v-if="(application.loan.asset.type == 'Vehicle')">

          <PpsrSearchResultVehicle
            v-if="application.loan.asset.vehicle.ppsr"
            :ppsr-fetch-results="application.loan.asset.vehicle.ppsr.filtered_response_payload"
          />
          <md-dialog-alert
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content" />

          <loading-icon-text-button
            v-if="application.loan.id"
            class="md-primary md-sm"
            @click="search_ppsr('vin')"
            icon="search"
            :loading="loading_search_ppsr"
            :toolTipText="ppsrMessage"
            >
            Search PPSR by VIN

          </loading-icon-text-button>

          <loading-icon-text-button
            v-if="application.loan.id"
            class="md-primary md-sm"
            @click="search_ppsr('registration')"
            icon="search"
            :loading="loading_search_ppsr"
            :toolTipText="ppsrMessage"
            >
            Search PPSR by Registration
          </loading-icon-text-button>

          <loading-icon-text-button
            v-if="application.loan.asset.vehicle.ppsr && application.loan.asset.vehicle.ppsr_search_type === 'algodriven'"
            class="md-button-content md-sm"
            @click="check_ppsr_status()"
            icon="search"
            :loading="loading_search_ppsr">
            Check PPSR Status
          </loading-icon-text-button>

          <loading-icon-text-button
            v-if="showDriveRequestButton && this.security.loan_asset_type_id == 'V'"
            class="md-primary md-sm drive-button"
            :class="{'bg-button-grey': isDriveReqSent }"
            @click="confirmSendDriveWholesaleDialog"
            icon="file_upload"
            :loading="loading"
            >
            Send To Drive Approved
          </loading-icon-text-button>
        </div>
      </md-tab>

      <md-tab id="Marine" md-label="Marine">
        <AssetSecurityEditor securityType="marine" :value="application"></AssetSecurityEditor>
      </md-tab>

      <md-tab id="Leisure" md-label="Leisure">
        <AssetSecurityEditor securityType="leisure" :value="application"></AssetSecurityEditor>
      </md-tab>

      <md-tab id="Cashflow" md-label="Cashflow" :md-disabled="!isCommercialLoan">
        <div class="boxed-category">
          <md-subheader>Cashflow Details</md-subheader>
        <div class="md-layout input-layout">
          <!-- Description -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-40"
            label="Description"
            prefixLabel="Cashflow"
            v-model="application.loan.asset.cashflow.description"
          >
          </validated-text-input>

          <!-- Purchase Cost -->
          <validated-input
            type="CURRENCY"
            class="md-layout-item md-small-size-100 md-size-15"
            label="Requested Loan Amount"
            prefixLabel="Cashflow"
            prefix="$"
            v-model="application.loan.asset.cashflow.requested_amount"
          />
        </div>
        </div>
      </md-tab>

      <md-tab id="Equipment" md-label="Equipment" :md-disabled="!isCommercialLoan">
        <AssetSecurityEditor securityType="equipment" :value="application"></AssetSecurityEditor>
      </md-tab>
    </md-tabs>
    <div>
        <loading-icon-text-button
        v-if="showDriveRequestButton && this.security.loan_asset_type_id != 'V'"
        class="md-primary md-sm drive-button"
        :class="{'bg-button-grey': isDriveReqSent}"
        @click="confirmSendDriveWholesaleDialog"
        :loading="loading"
        icon="file_upload"
        >
        Send To Drive Approved
      </loading-icon-text-button>
      <md-dialog class="md-layout" :md-active.sync="driveRequestDialog">
        <div class="wrapper">
          <p>This will send the API Request to Drive Team</p>
          <md-checkbox class="md-layout-item md-size-30" v-model="approvedByBroker">
            Approved
          </md-checkbox>
          <div v-if="showLVRInput">
            <validated-number-input
              class="md-layout-item md-small-size-100 md-size-15"
              label="LVR"
              v-model="lvr"
            >
            </validated-number-input>
          </div>

          <div>
            <validated-number-input
              class="md-layout-item md-small-size-100 md-size-15"
              label="Lender Approved Amount"
              v-model="lenderApprovedAmount"
            >
            </validated-number-input>
          </div>

          <div style="width: 100%;">
            <validated-text-input
              class="md-layout-item md-small-size-100 md-size-40"
              label="Comment (required)"
              v-model="comment"
              errormsg="Please enter a comment"
              required
            >
            </validated-text-input>
          </div>


          <md-dialog-actions>
            <md-button class="md-primary md-simple" @click="onCloseDriveRequestDialog">
              Cancel
            </md-button>
            <loading-icon-text-button @click="confirmRequest" :loading="loading" :disabled="!comment">
              Send Request
            </loading-icon-text-button>
          </md-dialog-actions>
        </div>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import PpsrSearchResultVehicle from '@/components/Search/PpsrSearchResultVehicle';
import LoadingIconTextButton from "../LoadingIconTextButton";
import PropertyView from '@/components/ApplicationSummary/PropertyView';
import AssetSecurityEditor from "./SecurityEditors/AssetSecurityEditor";
import AssetValueEditor from "./SecurityEditors/AssetValueEditor";
import AlertDialog from "../Dialogs/AlertDialog";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";

export default {
  data() {
    return {
      isDriveReqSent: false,
      loading_search_ppsr: false,
      alertMessage: false,
      message: '',
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      show_glasses: false,
      ppsrMessage: '',
      driveRequestDialog: false,
      showDriveRequestButton: false,
      showLVRInput: false,
      lvr: 0,
      comment: '',
      loading: false,
      approvedByBroker: false,
      lenderApprovedAmount: 0,
    }
  },
  components: {
    AssetValueEditor,
    AssetSecurityEditor,
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    PpsrSearchResultVehicle,
    LoadingIconTextButton,
    PropertyView,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
    "application.loan.type"() {
      return this.isCommercialLoan;
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      makers: "makers",
      models: "models",
      glasses: "glasses",
      properties: "properties",
      security: "security",
      application: "application",
      userHasRole: "userHasRole"
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      },
    },
    isCommercialLoan() {
      let allLoanTypes = this.properties.loan_application_type_properties ?? "Personal";
      let currentLoanType = this.application.loan.type;
      let commercialLoan = [];
      Object.keys(allLoanTypes).forEach(function (key) {
        if (allLoanTypes[key].commercial) {
          commercialLoan.push(allLoanTypes[key].name);
        }
      });
      return commercialLoan.includes(currentLoanType);
    }
  },
  created() {
    this.checkStatus();
    this.checkDriveRequestButtonPermissions();
    this.checkDriveReqStatus(); // check if wholesale drive request has been sent
  },
  methods: {
    // make all filters available as methods
    ...filters,
    async search_ppsr(search_type) {
      try {
        this.loading_search_ppsr = true;
        let compare_value = '';
        let search_value = '';
        let compare_search_value = '';

        if (this.application.loan.asset.vehicle &&
          this.application.loan.asset.vehicle.ppsr &&
          this.application.loan.asset.vehicle.ppsr.request_value) {
          compare_value = this.application.loan.asset.vehicle.ppsr.request_value;
        }

        switch (search_type) {
          case 'vin':
            search_value = this.application.loan.asset.vehicle.vin;
            compare_search_value = search_value

            let regExp = /[IOQioq]/g;
            // compare input value and db ppsrSearch request_value and type
            if (search_value.length != 17 || regExp.test(search_value)) {
              this.error_dialog.title = `Failed to search by ${search_type}`;
              this.error_dialog.content = `The following error occurred: Invalid VIN number, cannot contain I, O or Q letters and VIN number length must be 17`;
              this.error_dialog.show = true;
              return false;
            }

            break;
          case 'registration':
            let reg = this.application.loan.asset.vehicle.registration;
            let state = this.application.loan.asset.vehicle.state;

            if (reg && state) {
              search_value = {
                reg: reg,
                state: state
              };

              compare_search_value = JSON.stringify(search_value)
            } else {
              this.error_dialog.title = `Failed to search by ${search_type}`;
              this.error_dialog.content = `The following error occurred: Invalid registration number or registration state`;
              this.error_dialog.show = true;
              return false;
            }
            break;
        }

        if (this.application.loan &&
          ((search_type == 'vin' && search_value.length == 17) || search_type == 'registration') &&
          compare_search_value === compare_value) {
          if (!confirm('you have already successfully searched this VIN, another successful search will incur another ppsr lookup fee, want to search again?')) {
            return false;
          }
        }

        let ppsr_type = this.application.loan.asset.vehicle.ppsr_search_type ?? 'algodriven';

        // search by ppsr
        let result = await this.$store.dispatch(
          'request_by_ppsr', {
            application: this.application,
            search_value: search_value,
            search_type: search_type,
            ppsr_type: ppsr_type,
          });

        if (result) {
          this.application.loan.asset.vehicle.ppsr = this.$store.getters.ppsrSearchResults;
        }

      } catch (error) {
        console.error(error);
        if (error.response.status == 500) {
          this.application.loan.asset.vehicle.ppsr = '';
        }
        this.error_dialog.title = `Failed to search by ${search_type}`;
        this.error_dialog.content = `The following error occurred: ${error.response.data}`;
        this.error_dialog.show = true;
        return false;
      } finally {
        this.loading_search_ppsr = false;
      }
    },
    async check_ppsr_status() {
      this.loading_search_ppsr = true;
      try {
        let searchNumber = this.application.loan.asset.vehicle.ppsr.filtered_response_payload.ppsr_search_details.SearchNumber;
        let result = await this.$store.dispatch('check_ppsr_status', {searchNumber: searchNumber});

        if (result) {
          let ppsrStatus = this.$store.getters.getPpsrStatus;
          this.ppsrMessage = ppsrStatus.msg;
          return this.showModal("Message : " + ppsrStatus.msg, "Status : " + ppsrStatus.status);
        } else {
          this.error_dialog.title = `Failed to get status`;
          this.error_dialog.content = `Failed to get Status of PPSR`;
          this.error_dialog.show = true;
        }
      } catch (error) {
        console.error('ppsr check status request failed');
        console.error(error);
        this.error_dialog.title = `ppsr check status request failed`;
        this.error_dialog.content = `The following error occurred: ${error.response.data}`;
        this.error_dialog.show = true;
        return false;
      } finally {
        this.loading_search_ppsr = false;
      }
    },
    showModal(message, title) {
      this.$modal.show(AlertDialog, {
        title: title,
        message: message,
      });
      this.loading_search_ppsr = false;
    },
    async checkStatus() {
      if (this.application.loan.asset.vehicle.ppsr) {
        this.loading_search_ppsr = true;
        try {
          const searchNumber = this.application.loan.asset.vehicle.ppsr.filtered_response_payload.ppsr_search_details.SearchNumber;
          const result = await this.$store.dispatch('check_ppsr_status', {searchNumber: searchNumber});

          if (result) {
            const ppsrStatus = this.$store.getters.getPpsrStatus;
            this.ppsrMessage = ppsrStatus.msg ?? '';
          } else {
            console.log('Failed to get status');
          }
        } catch (error) {
          console.error('ppsr check status request failed');
          console.error(error);
        } finally {
          this.loading_search_ppsr = false;
        }
      }
    },
    checkDriveRequestButtonPermissions() {
      if (this.userHasRole("super-admin")
        || this.userHasRole("Broker")) {
        this.showDriveRequestButton = true;
      }
    },
    async confirmSendDriveWholesaleDialog() {

      if (this.isDriveReqSent) { // confirm second request dialog
        let userAnswer = await this.showConfirmDialog("Warning", "Drive Wholesale request has already been submitted. Do you want to send another request?");
        if (!userAnswer) {
          return;
        }
      }
      if (this.security.value == 0 || this.application.loan.submission.active.naf == 0 || this.application.loan.submission.active.naf == null) {
        this.showLVRInput = true;
      } else {
        this.showLVRInput = false;
      }

      this.lenderApprovedAmount = this.application.loan.submission.active.naf ? this.application.loan.submission.active.naf : 0;
      this.driveRequestDialog = true;
    },
    onCloseDriveRequestDialog() {
      this.driveRequestDialog = false;
    },
    async confirmRequest() {
      if (this.lvr <= 0 && this.showLVRInput == true) {
        this.showModal("Please make sure you entered the LVR", "");
        return;
      }
      if (this.comment.trim().length < 2) {
        this.showModal("Comment is required", "");
        return;
      }
      if (!this.approvedByBroker) {
        this.showModal("The Lead have to by Approved", "");
        return;
      }
      this.loading = true;
      const response = await axios.post(
        "/api/v1/application/send_drivewholesale_request",
        {
          application_id: this.application.loan.id,
          lvr: this.showLVRInput ? this.lvr : null,
          lenderApprovedAmount: this.lenderApprovedAmount,
          broker_notes: this.comment
        });
      this.loading = false;
      let status, message;
      if (response.data.status == 202) {
        status = "Success"
        message = "Request sent to Drive Sucessfully";
        this.isDriveReqSent = true; //change button colour to grey
      } else {
        status = "Failed"
        message = "Request sent to Drive Failed";
        this.isDriveReqSent = false; //change button colour back to green
      }
      this.showModal(message, status);
      this.onCloseDriveRequestDialog();
    },
    async checkDriveReqStatus() {
      if(!!this.application.loan.id) {
        await axios.get(`/api/v1/application/drivewholesale_request_is_sent/${this.application.loan.id}`)
        .then((res) => {
          if (res.data.success) {
            this.isDriveReqSent = true; //change button colour to grey
          }
          else {
            console.log(res.data.data);
          }
        })
        .catch((err) => {
          if (err.response.status === 500) {
            this.showNotificationDialog("Warning", err.response.data.data);
          }
          console.error(err.response.data.data);
        });
      }
    },
    showNotificationDialog(title, message) {
      this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: 'Ok',
      });
    },
    showConfirmDialog(title, message) {
      return this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: 'Yes',
        cancelText: 'No',
      });
    }
  },
  async beforeCreate() {
    const params = {
      types: [
        'loan_application_type_properties'
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  filters: {
    // make all filters available as filters
    ...filters,
  }
};
</script>

<style scoped>
  .action-buttons {
    float: left;
  }

  .loading_icon_position {
    top: 10px;
    position: relative;
    left: 10px;
  }

  .right {
    float: right;
  }

  .wrapper {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 25vw;
    height: auto;
    padding: 20px 20px 20px 15px;
  }

  .drive-button {
    margin-left: 10px;
    background-color: #4caf50 !important;
  }

  .bg-button-grey {
    background-color:  #aaacaa !important;
  }
  .bg-button-grey :hover,
  .bg-button-grey :focus,
  .bg-button-grey :active {
    background-color:  #6a6a6a!important;
  }
</style>
